export default __webpack_public_path__ + "static/lut-virusi-eye-virus-banner-hd-44478141849ed73e58ba7d0afdfd3f21.jpg";